import { teamRoles } from "astrid-firestore/src/constants/teamRoles";

export default function recorderHasDefaultPrice({ production, user }) {
	return !!user?.prices?.[production.producer]?.[`${production.language}-${teamRoles.RECORDER}`];
}
